import { defineStore } from 'pinia';
import state from './state.js';
import actions from './actions.js';

export const useInterAccountLeadsStore = defineStore('interAccountLeads', {
    state() {
        return state;
    },
    actions,
});
